import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { InsurerService } from '../service/insurer.service';

@Injectable({
    providedIn: 'root'
})
export class InsurerValidators
{
    constructor(private insurerService: InsurerService) { }

    public validateInsurerNameUnique(control: UntypedFormControl, initialCategoryName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialCategoryName !== control.value)
            {
                this.insurerService.existsInsurerName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
